var map = {
	"./yy1.png": 2427,
	"./yy10.png": 7987,
	"./yy2.png": 8928,
	"./yy3.png": 9481,
	"./yy4.png": 6406,
	"./yy5.png": 7804,
	"./yy6.png": 6516,
	"./yy7.png": 7645,
	"./yy8.png": 3578,
	"./yy9.png": 2435
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1095;